import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputFieldComponent } from '../input-field/input-field';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'lib-search-input',
  imports: [InputFieldComponent, IconComponent, FormsModule],
  templateUrl: './search-input.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchInputComponent {
  placeholder = input<string>('');
  value = input<string>('');
  valueChange = output<string>();
  private timer: number | undefined;

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
      this.valueChange.emit(input.value);
    }, 300);
  }
}
